export default "__VITE_ASSET__uNZHVXRa__"